import Router from './router.js';
// binds the keys of a route ("a/b/*/c") to the parts of the URL
function initRouter(obj, route, type) {
  Router[type || 'hash'].subscribe(obj, route);
  return obj;
}
export { initRouter, Router };